// import logo from './logo.svg';
import './App.css';
import React from 'react';
import Chatbot from 'react-chatbot-kit'
import './/main2.css'

import ActionProvider from './ActionProvider';
import MessageParser from './MessageParser';
import config from './config';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Chatbot
            config={config}
            actionProvider={ActionProvider}
            messageParser={MessageParser}
            placeholderText='Write your question here'
        />
      </header>
    </div>
  );
}

export default App;
